import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { AuditTrailDetailModal, FieldChangeModal } from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-registered-company',
	templateUrl: './registered-company.component.html',
	styleUrls: [ './registered-company.component.scss' ]
})
export class RegisteredCompanyComponent implements OnInit {
	workflows;
	projectId: string;
	workflowFields;
	success: any;
	error: any;
	pending: boolean;
	filter: AppFilter = new AppFilter();
	totalItems: number = 5;
	rows: number = 2;
	currentPage: number = 1;
	maxSize: number = 7;
	constructor(
		private modalService: SuiModalService,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {
		this.activatedRoute.parent.params.subscribe((params) => {
			this.projectId = params['id'];
		});
	}
	detailCompany(event) {}
	deactivateCompany(event) {}
	serviceAccess(event) {}
	chatCompany(event) {}
	verifyCompany(event) {}

	deleteMulti() {}
	addCompany() {}
	viewCompany(event) {
		this.modalService
			.open(
				new AuditTrailDetailModal('Row Data', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny)
			)
			.onApprove((payload) => {
				// this.addWorkflowGroup(payload);
			})
			.onDeny(() => {});
	}
	viewChangeField(event) {
		this.modalService
			.open(
				new FieldChangeModal('Changed Field', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny)
			)
			.onApprove((payload) => {
				// this.addWorkflowGroup(payload);
			})
			.onDeny(() => {});
	}

	onDelete() {}

	delete(app) {
		this.modalService
			.open(
				new ConfirmModal('Delete Workflow?', 'Are you sure you want to delete this workflow?', ModalSize.Tiny)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	goBack() {
		this.location.back();
	}
	searchRecords(event) {}
	displayRecords(event) {}
	sortRecords(event) {}
	nextPage(event) {}

	ngOnInit(): void {}
}
